import { useQuery } from '@tanstack/react-query';
import type { UserDto, ListUsersQuery } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface UsersListApiResponse {
  success: boolean;
  data: UserDto[];
  meta: {
    nextCursor: string | null;
    hasMore: boolean;
    limit: number;
  };
}

/**
 * Hook to retrieve the list of users in the current tenant.
 * Calls GET /users.
 */
export function useUsersList(filters?: ListUsersQuery) {
  return useQuery({
    queryKey: queryKeys.users.list(filters),
    queryFn: async () => {
      const response = await apiClient.get<UsersListApiResponse>('/users', {
        params: filters,
      });
      return response.data;
    },
  });
}
